export const FONT = "'Inter', -apple-system, BlinkMacSystemFont, sans-serif";

export const COLORS = {
  bg: "#F8FAFC",
  card: "#FFFFFF",
  surface: "#F1F5F9",
  surfaceHover: "#E2E8F0",
  text: "#0F172A",
  textSecondary: "#475569",
  muted: "#64748B",
  dim: "#94A3B8",
  border: "#E2E8F0",
  borderLight: "#F1F5F9",
  primary: "#2563EB",
  primaryLight: "#DBEAFE",
  green: "#059669",
  greenLight: "#D1FAE5",
  red: "#DC2626",
  redLight: "#FEE2E2",
  orange: "#D97706",
  orangeLight: "#FEF3C7",
  pink: "#DB2777",
  blue: "#2563EB",
  blueLight: "#DBEAFE",
};

export const GRADIENT = "linear-gradient(135deg, #2563EB, #7C3AED)";

export const FontLink = () => (
  <link
    href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
    rel="stylesheet"
  />
);
